import { ArrowRightIcon, AttachIcon, PersonIcon } from '../icons';
import { Orb } from './primitives';

const QUICK_REPLIES = [
  'Помогите с отсрочкой от призыва',
  'Положена ли мне выплата военнослужащему',
  'Как обжаловать решение комиссии',
];

/** Мок интерфейса чата с юристом (hero). */
export function ChatMockup() {
  return (
    <div className="relative mx-auto w-full max-w-[700px]">
      <div className="relative z-10 rounded-[26px] border border-white/85 bg-white/56 shadow-chat backdrop-blur-[18px] md:rounded-[32px]">
        <div className="flex items-center gap-3.5 border-b border-line px-5 py-3.5 md:px-7">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-soft">
            <PersonIcon className="h-6 w-6 text-accent" />
          </span>
          <div className="min-w-0">
            <div className="text-[17px] font-semibold text-ink">Анна Смирнова</div>
            <div className="text-[14px] text-muted">Военный юрист · на связи</div>
          </div>
          <span className="ml-auto inline-flex items-center gap-1.5 rounded-lg bg-success-soft px-3 py-1.5 text-[12px] font-semibold text-success sm:w-[288px] sm:min-w-[288px] sm:justify-center sm:px-3.5 sm:py-2 sm:text-[14px]">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-success" />
            <span className="sm:hidden">9:00–21:00</span>
            <span className="hidden sm:inline">Ежедневно 9:00–21:00 по Москве</span>
          </span>
        </div>

        <div className="flex flex-col gap-3 px-4 py-4 md:px-6">
          <div className="ml-auto max-w-[88%] rounded-2xl rounded-br-md bg-accent-gradient px-4 py-3 text-[15px] leading-snug text-white">
            Здравствуйте! Грозит ли мне призыв, если есть отсрочка по учёбе?
          </div>

          <div className="max-w-[92%] rounded-2xl rounded-bl-md bg-white/95 px-4 py-3 text-[15px] leading-relaxed text-ink shadow-sm">
            Отсрочка по учёбе сохраняется, если программа аккредитована, а сроки обучения не
            нарушены. Подскажите, в каком заведении и на каком курсе вы учитесь — подберём порядок
            действий.
          </div>

          <div className="rounded-2xl bg-white/95 p-4 shadow-sm">
            <div className="mb-3 text-[15px] font-semibold text-ink">Частые вопросы</div>
            <div className="flex flex-col gap-2">
              {QUICK_REPLIES.map((reply) => (
                <span
                  key={reply}
                  className="flex items-center justify-between gap-3 rounded-[10px] border border-line bg-white/90 px-3.5 py-2.5 text-[14px] font-medium text-ink"
                >
                  {reply}
                  <ArrowRightIcon className="h-4 w-4 shrink-0 text-accent" />
                </span>
              ))}
            </div>
          </div>

          <div className="mt-1 flex items-center gap-2.5 rounded-2xl border border-line bg-white/95 px-4 py-2.5">
            <Orb className="h-5 w-5" />
            <span className="flex-1 truncate text-[14px] text-muted">Опишите вашу ситуацию…</span>
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-soft text-muted">
              <AttachIcon className="h-4 w-4" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-gradient text-white">
              <ArrowRightIcon className="h-4 w-4" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
